/**
 * Document configuration - centralizes all document field definitions
 */

import { File as FileEnum } from "@funded-here-interface/common/src/constant/enum";
import { DocumentConfig } from "./types";
import {
  setBusinessDoc,
  setProofDoc,
  setShareDoc,
  setBankDoc,
  setBalance,
  setCertificateOfIncorporationDoc,
  setSupportingDocumentsWithSuppliersDoc,
} from "../../features/merchant/doc";

/**
 * Centralized document configuration
 * Maps file types to Redux fields and validation labels
 */
export const DOCUMENT_CONFIGS: DocumentConfig[] = [
  {
    fileType: FileEnum.CERTIFICATE_OF_INCORPORATION,
    reduxField: "certificateOfIncorporation",
    validationLabel: "certificate of incorporation",
  },
  {
    fileType: FileEnum.BUSINESS_PROFILE,
    reduxField: "businessProfile",
    validationLabel: "company/business Profile",
  },
  {
    fileType: FileEnum.SHAREHOLDERS_DIRECTORS_REGISTERS,
    reduxField: "shareHoldersDirectorsRegisters",
    validationLabel: "shareholder and directors registers file",
  },
  {
    fileType: FileEnum.BANK_STATEMENT,
    reduxField: "bankStatement",
    validationLabel: "proof of bank account details",
  },
  {
    fileType: FileEnum.PROOF_OF_ADDRESS,
    reduxField: "proofOfAddress",
    validationLabel: "proof of residential address",
  },
  {
    fileType: FileEnum.BALANCE_SHEET,
    reduxField: "balanceSheetPAndLStatement",
    validationLabel: "financial documents",
  },
  {
    fileType: FileEnum.SUPPORTING_DOCUMENTS_WITH_SUPPLIERS,
    reduxField: "supportingDocumentsWithSuppliers",
    validationLabel: "supporting documents with suppliers",
  },
];

/**
 * Redux action creators mapped by file type
 */
export const REDUX_ACTION_MAP = {
  [FileEnum.CERTIFICATE_OF_INCORPORATION]: setCertificateOfIncorporationDoc,
  [FileEnum.BUSINESS_PROFILE]: setBusinessDoc,
  [FileEnum.SHAREHOLDERS_DIRECTORS_REGISTERS]: setShareDoc,
  [FileEnum.BANK_STATEMENT]: setBankDoc,
  [FileEnum.PROOF_OF_ADDRESS]: setProofDoc,
  [FileEnum.BALANCE_SHEET]: setBalance,
  [FileEnum.SUPPORTING_DOCUMENTS_WITH_SUPPLIERS]:
    setSupportingDocumentsWithSuppliersDoc,
} as const;

/**
 * Constants
 */
export const UPLOAD_INFO_TEXT_LINE1 =
  "All uploads must be in PDF format. The file size should not exceed 10MB each.";
export const UPLOAD_INFO_TEXT_LINE2 =
  "We may request for additional supporting documents beyond those listed here as part of our onboarding and verification process.";
